<template>
  <div class="clocking-site-container">
    <div class="clocking-site-body">
      <div class="clocking-site-title">
        <h3>考勤地址管理</h3>
      </div>
      <div class="clocking-site-content">
        <div class="title-operation">
          <el-input placeholder="请输入标题/考勤地址" v-model="keyword" clearable @keyup.enter.native="getDataList"></el-input>
          <el-button class="search" @click="getDataList">查询</el-button>
          <el-button class="add-address" type="primary" @click="addAddress">添加考勤地址</el-button>
        </div>
        <div class="table">
          <el-table height="100%" :data="tableData" border ref="multipleTable" v-loading="loading">
            <el-table-column v-for="column in columnData"
                             :prop="column.prop"
                             :key="column.prop"
                             :label="column.label"
                             :resizable="column.resizable"
                             :show-overflow-tooltip="true"
                             :align="column.align"
                             v-cloak
            ></el-table-column>
            <el-table-column label="操作" :resizable="false" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="compileRule(scope.row)">编辑</el-button>
                <el-button class="delete" type="text" @click="deleteRow(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          @size-change="val => pagination.pageSize = val"
          @current-change="val => pagination.currentPage = val"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next, sizes"
          :total="pagination.total"
          :page-sizes="pagination.pageSizes"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="dialogParameter.title + '考勤地址'"
      top="10vh"
      :visible.sync="dialogParameter.dialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="add-address-body">
        <el-form label-position="left" ref="addAddress" label-width="80px" :model="formData" :rules="formData_rules">
          <el-form-item label="标题" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <el-form-item label="考勤地址" prop="address">
            <el-input v-model="formData.address" :title="formData.address ? formData.address : ''"></el-input>
          </el-form-item>
          <el-form-item label="有效距离" prop="distance">
            <el-input v-model="formData.distance">
              <template slot="append">米</template>
            </el-input>
          </el-form-item>
          <el-form-item label="经度" prop="longitude">
            <el-input v-model="formData.longitude"></el-input>
          </el-form-item>
          <el-form-item class="bottom" label="纬度" prop="latitude">
            <el-input v-model="formData.latitude"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-link href="https://lbs.amap.com/console/show/picker" target="_blank" type="primary">点击前往高德获取经纬度</el-link>
          </el-form-item>
        </el-form>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="dialogParameter.dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const columnData = [
  {
    prop: 'title',
    label: '标题',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'address',
    label: '考勤地址',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'longitude',
    label: '经度（度）',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'latitude',
    label: '纬度（度）',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'distance',
    label: '有效距离（米）',
    resizable: false,
    align: 'center'
  }
]
export default {
  name: 'clockingSite',
  data () {
    let isLongitude = (rule, value, callback) => {
      if (isNaN(parseFloat(value))) {
        return callback(new Error('请输入数字'))
      } else {
        if (parseFloat(value) > 180) {
          return callback(new Error('经度最大为180'))
        } else {
          return callback()
        }
      }
    }
    let isLatitude = (rule, value, callback) => {
      if (isNaN(parseFloat(value))) {
        return callback(new Error('请输入数字'))
      } else {
        if (parseFloat(value) > 90) {
          return callback(new Error('纬度最大为90'))
        } else {
          return callback()
        }
      }
    }
    let isDistance = (rule, value, callback) => {
      if (/^[1-9]\d*$/.test(value)) {
        return callback()
      } else {
        return callback(new Error('请输入正整数'))
      }
    }
    return {
      tableData: [],
      columnData,
      dialogParameter: {
        title: '添加',
        dialogVisible: false
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [10, 20, 50, 100]
      },
      keyword: '',
      // 搜索数据
      formData: {
        title: '',
        address: '',
        longitude: '',
        latitude: '',
        distance: ''
      },
      // 校验规则
      formData_rules: {
        title: [
          {
            required: true,
            message: '请输入考勤地址标题',
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: '请输入考勤地址',
            trigger: 'blur'
          }
        ],
        longitude: [
          {
            required: true,
            message: '请输入经度',
            trigger: 'blur'
          },
          {
            validator: isLongitude,
            trigger: 'blur'
          }
        ],
        latitude: [
          {
            required: true,
            message: '请输入纬度',
            trigger: 'blur'
          },
          {
            validator: isLatitude,
            trigger: 'blur'
          }
        ],
        distance: [
          {
            required: true,
            message: '请输入有效范围',
            trigger: 'blur'
          },
          {
            validator: isDistance
          }
        ]
      },
      isEdit: false,
      // 删除与编辑用的id
      rowId: '',
      loading: false
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    // 编辑弹框
    compileRule (row) {
      this.formData = {...row}
      this.rowId = row.id
      this.isEdit = true
      this.dialogParameter.title = '编辑'
      this.dialogParameter.dialogVisible = true
    },
    // 删除弹框
    deleteRow (row) {
      this.rowId = row.id
      this.$confirm('是否确认删除？', '', {
        confirmButtonText: '是的，我确认删除',
        cancelButtonText: '容我重新思考一下',
        customClass: 'deleMessageBox-custom'
      }).then(() => this.deleteItem(row.id)).catch(() => {})
    },
    // 删除
    deleteItem (id) {
      this.$axios.delete(`/auth-api/address/${id}`).then(() => this.getDataList())
    },
    // 获取列表数据
    async getDataList () {
      this.loading = true
      try {
        let params = {
          filters: {keyword: this.keyword},
          index: this.pagination.currentPage,
          size: this.pagination.pageSize
        }
        await this.$axios.get(`/auth-api/address`, {params}).then(res => {
          this.tableData = res.data.items || []
          this.pagination.total = res.data.total
        })
      } finally {
        this.loading = false
      }
    },
    // 添加考勤地址
    addAddress () {
      this.dialogParameter.title = '添加'
      this.isEdit = false
      this.formData.title = ''
      this.dialogParameter.dialogVisible = true
    },
    closeDialog () {
      this.$set(this, 'formData', {
        title: '',
        address: '',
        longitude: '',
        latitude: '',
        distance: ''
      })
      this.rowId = ''
      this.isEdit = false
      this.$refs.addAddress.resetFields()
    },
    // 保存
    saveData () {
      let data = { ...this.formData }
      this.isEdit && (data.id = this.rowId)
      this.$refs.addAddress.validate(valid => {
        if (valid) {
          this.$axios.post(`/auth-api/address`, data).then(res => {
            this.dialogParameter.dialogVisible = false
            this.getDataList()
          })
        } else {
          return false
        }
      })
    }
  },
  watch: {
    'pagination.currentPage' (val) {
      this.getDataList()
    },
    'pagination.pageSize' (val) {
      this.getDataList()
    },
    'dialogParameter.dialogVisible' (val) {
      if (!val) {
        this.closeDialog()
      }
    }
  }
}
</script>

<style lang="scss">
  .clocking-site-container {
    padding: 10px;
    height: 100%;

    div, span, p, label {
      font-size: 12px;
    }

    .clocking-site-body {
      background: #fff;
      box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
      border-radius: 4px 0;
      height: 100%;
    }

    .clocking-site-title {
      padding: 10px;
      border-bottom: 1px solid #edeeee;

      h3 {
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }
    }

    .clocking-site-content {
      padding: 15px 0;
      height: calc(100% - 60px);

      .title-operation {
        padding-left: 20px;
        position: relative;
        & > .el-input {
          width: 250px;
        }
        .search {
          margin-left: 20px;
          width: 40px;
          height: 24px;
          border: 1px solid var(--primary, #55ACF1);
          color: var(--primary, #55ACF1);
          padding: 0;
          border-radius: 4px;
        }
        .add-address {
          position: absolute;
          right: 20px;
        }
      }
      .table {
        padding-top: 15px;
        height: calc(100% - 40px);
        .el-table {
          .el-table__body-wrapper {
            .el-table__row {
              .cell {
                .delete {
                  color: #ff4a4a;
                }
                .el-button+.el-button {
                  margin-left: 20px;
                }
              }
            }
          }
        }
      }
      .el-pagination {
        text-align: right;
        padding-top: 10px;
        .el-pagination__sizes .el-input {
          width: 86px;
        }
        .el-pagination__jump .el-input {
          width: 40px;
        ;
        }
        &.is-background  {
          .btn-next,  .btn-prev, .el-pager li {
            margin: 0 10px;
            background:rgb(255,255,255);
            border:1px solid rgb(235,235,235);
            color: #C7C7CC;
            border-radius: 4px;
          }
          .el-pager li {
            margin: 0;
            border-right: none;
            border-radius: 0;
            &:first-child {
              border-top-left-radius: 4px;
              border-bottom-left-radius: 4px;
            }
            &:last-child {
              border-right:1px solid rgb(235,235,235);
              border-top-right-radius: 4px;
              border-bottom-right-radius: 4px;
            }
          }
          .el-pager li:not(.disabled).active{
            background:var(--light-9, rgb(232,240,252));
            color: var(--primary, #4D9BDA);
          }
        }
      }
    }

    .el-dialog__wrapper {
      .el-dialog {
        .el-dialog__body {
          .el-form {
            .bottom {
              margin-bottom: 8px;
            }
            .is-success {
              .el-form-item__content {
                .el-input {
                  .el-input__inner {
                    border-color: #DCDFE6;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system/system/clocking-site.vue